<template>
  <div class="app-container">
    <div class="navbar-group">
      <el-button type="primary" @click.native="RestartOrder" :disabled="!canWrite">新增</el-button>
      <el-button
        type="primary"
        @click.native="save"
        :disabled="(data.Status == 2 && !is_orderUpdateStatus) || !canWrite"
        >保存</el-button
      >
      <el-button
        type="primary"
        @click.native="orderUpdate"
        :disabled="data.Status != 2 || !canWrite"
        >变更</el-button
      >
      <el-button
        type="primary"
        @click.native="orderDel"
        :disabled="!isSave || data.Status == 2 || !canWrite"
        >删除</el-button
      >
      <el-button
        type="primary"
        @click.native="orderReview"
        :disabled="!isSave || !canReview"
        >{{ ReviewName }}</el-button
      >
      <el-dropdown>
        <el-button type="primary" :disabled="!isSave">
          联查<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown" style="margin-left: 4px">
          <el-dropdown-item class="dropdown-item" @click.native="goJump(1)"
            >采购订单情况</el-dropdown-item
          >
          <el-dropdown-item class="dropdown-item" @click.native="goJump(2)"
            >采购需求分析情况</el-dropdown-item
          >
          <el-dropdown-item class="dropdown-item" @click.native="goJump(3)"
            >销售订单情况</el-dropdown-item
          >
          <!-- <el-dropdown-item class="dropdown-item" @click.native="goJump(4)">预测单情况</el-dropdown-item> -->
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="primary" @click="openPrint" :disabled="!isSave"
        >打印</el-button
      >
    </div>
    <el-form
      :inline="true"
      :model="data"
      :line-form="true"
      label-width="90px"
      ref="ruleForm"
      :rules="rules"
      status-icon
    >
      <el-row>
        <!-- 单据日期 -->
        <el-form-item label="单据日期:" prop="OrderDate" label-width="90px">
          <span class="not-edit" v-if="ReviewStatus">{{
            $commonJs.toDateString(data.OrderDate)
          }}</span>
          <el-date-picker
            v-else
            v-model="data.OrderDate"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            placeholder="选择日期"
            style="width: 190px"
            :clearable="false"
            @change="(val) => previewNo(val)"
          />
        </el-form-item>
        <el-form-item label="单据编码:" prop="OrderNo" label-width="90px">
          <span
            v-if="Mode == 0 || ReviewStatus"
            class="not-edit"
            style="min-width: 190px"
            >{{ data.OrderNo }}</span
          >
          <el-input
            v-else
            v-model="data.OrderNo"
            placeholder="请输入单据编码"
            style="min-width: 190px"
          />
        </el-form-item>

        <el-form-item label="需求日期:">
          <span class="not-edit" v-if="ReviewStatus">{{
            $commonJs.toDateString(data.DemandDate)
          }}</span>
          <el-date-picker
            v-else
            v-model="data.DemandDate"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            placeholder="选择日期"
            style="width: 180px"
          >
          </el-date-picker>
        </el-form-item>

        <!-- 经手人 -->
        <el-form-item label="经手人:" prop="ClerkId" label-width="90px">
          <span class="not-edit" v-if="ReviewStatus">{{ data.ClerkName }}</span>
          <select-input
            v-else
            placeholder="请选择经办人"
            :label="data.ClerkName"
            v-model="data.ClerkId"
            @click="openEmp"
            style="width: 190px"
          />
        </el-form-item>
        <!-- 制单人 -->
        <el-form-item label="制单人:" label-width="90px">
          {{ data.MakeEmpName }}
        </el-form-item>

        <el-col :span="12">
          <!-- 到货地址 -->
          <el-form-item label="到货地址:">
            <span class="not-edit" v-if="ReviewStatus">{{ data.Address }}</span>
            <el-input
              v-else
              type="textarea"
              v-model="data.Address"
              maxlength="60"
              placeholder="请填写地址"
              :autosize="{ minRows: 1, maxRows: 2 }"
              style="width: 460px"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="备注:" label-width="90px">
            <span v-if="orderUpdateStatus">{{ data.Remark }}</span>
            <el-input
              v-else
              type="textarea"
              v-model="data.Remark"
              :autosize="{ minRows: 2, maxRows: 4 }"
              maxlength="60"
              placeholder="请填写备注信息"
              style="width: 600px"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <!--  -->
      <el-row style="margin: 0px 0 20px">
        <el-table
          border
          :data="tableList"
          class="tableList"
          :row-class-name="tableRowClassName"
          @row-click="addColumn"
          v-keymove="addList"
        >
          <insert-row @on-insert="onInsert" />
          <el-table-column min-width="160" align="left" label="备注">
            <template slot-scope="{ row }">
              <span v-if="ReviewStatus">{{ row.Remark }}</span>
              <el-input
                v-else
                v-model="row.Remark"
                @change="editT(row)"
                placeholder="请输入备注"
              />
            </template>
          </el-table-column>
          <el-table-column align="left" label="存货名称" min-width="120px">
            <template slot-scope="{ row }">
              <span v-if="ReviewStatus">{{ row.ProductName }}</span>
              <account-select
                v-else
                v-model="row.ProductName"
                :source="DAccount"
                @select="onSelect($event, row)"
                :pageSize="pageParams.pageSize"
                :pageIndex="pageParams.pageIndex"
                :listTotal="listTotal"
                @inputText="inputText($event, row)"
                @click.native="resetFun"
                @currentPage="currentPage($event, row)"
                :pageType="true"
              />
            </template>
          </el-table-column>
          <el-table-column align="left" label="规格型号">
            <template slot-scope="{ row }">
              <span>{{ row.ProductSpec }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="属性"
            prop="PropertyId"
            align="left"
            min-width="100"
            key="table1_6"
          >
            <template slot-scope="{ row }">
              <el-select
                v-if="row.UseProcess"
                v-model="row.PropertyId"
                @change="changeProperty($event, row)"
                :disabled="row.isSource"
              >
                <el-option
                  v-for="item in propertyList"
                  :key="item.PropertyId"
                  :label="item.PropertyName"
                  :value="item.PropertyId"
                ></el-option>
              </el-select>
              <span v-else style="text-align: center"></span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="颜色" min-width="120px">
            <template slot-scope="{ row, $index }">
              <el-select
                v-if="row.UseColor && !ReviewStatus"
                v-model="row.ColorId"
                @change="changeColor(row, $index)"
              >
                <el-option
                  v-for="item in row.Colors"
                  :key="item.ColorId"
                  :value="item.ColorId"
                  :label="item.ColorName"
                  :disabled="item.Status==0"
                />
              </el-select>
              <span v-else>{{ row.ColorName }}</span>
            </template>
          </el-table-column>

          <el-table-column align="left" label="采购单位" min-width="120px">
            <template slot-scope="{ row, $index }">
              <el-select
                v-if="row.Units && row.Units.length > 0 && !ReviewStatus"
                v-model="row.UnitId"
              >
                <el-option
                  v-for="item in row.Units"
                  :key="item.UnitId"
                  :value="item.UnitId"
                  :label="item.UnitName"
                  @click.native="compareSaUnit(item, row, $index)"
                ></el-option>
              </el-select>
              <span v-else>{{ row.UnitName }}</span>
            </template>
          </el-table-column>
          <!--  -->
          <el-table-column align="right" label="数量" min-width="120px">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ $commonJs.toThousands(row.Quantity)  }}</span>
              <el-input
                v-else
                v-quantity:[option]="option"
                type="text"
                v-model="row.Quantity"
                @change="changeQuantity($event, row, $index)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="数量2" min-width="120px">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ $commonJs.toThousands(row.Quantity2)  }}</span>
              <span v-else-if="row.UnitType == 0"></span>
              <el-input
                v-else
                type="text"
                v-model.number="row.Quantity2"
                @change="changeQuantity2($event, row, $index)"
                @blur="getChangeQuantity($event, row, $index)"
              />
            </template>
          </el-table-column>
          <el-table-column align="right" label="报价" min-width="100px" v-if="canPrice">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.Offer }}</span>
              <el-input
                v-else
                v-price
                type="text"
                v-model="row.Offer"
                :disabled="row.IsGift"
                @input="changeOffer(row, $index)"
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="金额" min-width="100px" v-if="canPrice">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ $commonJs.toThousands(row.Amount) }}</span>
              <el-input
                v-else
                v-decimals
                type="text"
                v-model="row.Amount"
                :disabled="row.IsGift"
                @input="changeAmount(row, $index)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="可用量">
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(getQuantity(row.ExistQuantity)) }}</span>
            </template>
          </el-table-column>

          <!-- <el-table-column align="center" label="条形码" min-width="140px">
            <template slot-scope="{ row }">
              <vue-barcode
                :value="row.ProductNo"
                width="1"
                height="20"
                fontSize="10"
              ></vue-barcode>
            </template>
          </el-table-column> -->
          <el-table-column align="left" label="存货编码" min-width="140px">
            <template slot-scope="{ row }">
              <span>{{ row.ProductNo }}</span>
            </template>
          </el-table-column>

          <el-table-column align="left" label="计量单位2" min-width="120px">
            <template slot-scope="{ row, $index }">
              <!-- <span>{{ row }}{{ $index }}</span> -->
              <el-select
                v-if="row.Units && row.Units.length > 0 && !ReviewStatus"
                v-model="row.UnitId2"
              >
                <el-option
                  v-for="item in row.Units"
                  :key="item.UnitId"
                  :value="item.UnitId"
                  :label="item.UnitName"
                  @click.native="compareUnitId(item, row, $index)"
                ></el-option>
              </el-select>
              <span v-else-if="row.UnitType == 0"></span>
              <span v-else>{{ row.Unit2Name }}</span>
            </template>
          </el-table-column>

          <el-table-column align="right" label="换算率">
            <template slot-scope="{ row, $index }">
              <span
                v-if="
                  (ReviewStatus || row.ChangeType == 0) && row.UnitType == 1
                "
                >{{ row.Rate }}</span
              >
              <span v-else-if="row.UnitType == 0"></span>
              <el-input
                v-else
                type="text"
                v-model="row.Rate"
                @input="RateChange($event, row, $index)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            align="left"
            label="建议供应商编码"
            min-width="160px"
          >
            <template slot-scope="{ row }">
              <span>{{ row.TradeUnitNo }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="建议供应商" min-width="130px">
            <template slot-scope="{ row }">
              <span v-if="ReviewStatus">{{ row.TradeUnitName }}</span>
              <select-input
                v-else
                placeholder="请选择供应商单位"
                :label="row.TradeUnitName"
                v-model="row.TradeUnitId"
                @click="openTradeunit(row)"
                style="width: 120px"
                @clear="clearTradeUnit(row)"
              />
              <!-- <el-select
                v-else
                v-model="row.TradeUnitId"
                filterable
                clear
                @change="changeTradeUnitRow($event, row, $index)"
              >
                <el-option v-for="item in tradeUnitList" :key="item.TradeUnitId" :label="item.FullName" :value="item.TradeUnitId"></el-option>
              </el-select> -->
            </template>
          </el-table-column>

          <el-table-column align="right" label="折扣%" min-width="100px" v-if="canPrice">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.Discount }}</span>
              <el-input
                v-else
                v-decimals
                type="text"
                v-model="row.Discount"
                :disabled="row.IsGift"
                @input="changeDiscount(row, $index)"
              />
            </template>
          </el-table-column>
          <el-table-column align="right" label="税率%" min-width="100px" v-if="canPrice">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.TaxRate }}</span>
              <el-input
                v-else
                v-decimals
                v-limit:value="{ max: 100, min: 0 }"
                type="text"
                v-model.number="row.TaxRate"
                :disabled="row.IsGift"
                @input="changeTaxRate(row, $index)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="单价" min-width="140px" v-if="canPrice">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.Price }}</span>
              <el-input
                v-else
                v-price
                type="text"
                v-model="row.Price"
                :disabled="row.IsGift"
                @change="changePrice(row, $index)"
              >
                <el-button
                  v-if="row.ProductName"
                  slot="append"
                  @click="openSales(row, $index)"
                  icon="el-icon-s-order"
                ></el-button>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="含税单价" min-width="100px" v-if="canPrice">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.TaxPrice }}</span>
              <el-input
                v-else
                v-price
                type="text"
                v-model="row.TaxPrice"
                :disabled="row.IsGift"
                @input="changeTaxPrice(row, $index)"
              ></el-input>
            </template>
          </el-table-column>

          <el-table-column align="right" label="税额" min-width="100px" v-if="canPrice">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ $commonJs.toThousands(row.TaxLimit) }}</span>
              <el-input
                v-else
                v-decimals
                type="text"
                v-model="row.TaxLimit"
                :disabled="row.IsGift"
                @input="changeTaxLimit(row, $index)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="含税金额" min-width="100px" v-if="canPrice">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ $commonJs.toThousands(row.TaxAmount) }}</span>
              <el-input
                v-else
                v-decimals
                type="text"
                v-model="row.TaxAmount"
                :disabled="row.IsGift"
                @input="changeTaxAmount(row, $index)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="折扣金额" min-width="100px" v-if="canPrice">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ $commonJs.toThousands(row.DiscountAmount) }}</span>
              <el-input
                v-else
                v-decimals
                type="text"
                v-model="row.DiscountAmount"
                :disabled="row.IsGift"
                @input="changeDiscountAmount(row, $index)"
              ></el-input>
            </template>
          </el-table-column>
          <!--  -->

          <!--  -->

          <el-table-column align="center" label="行中止">
            <template slot-scope="{ row }">
              <el-checkbox
                v-model="row.LineAbort"
                @change="changeLineAbort($event, row)"
                :disabled="isLineAbort || orderUpdateStatus"
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column align="center" label="中止人">
            <template slot-scope="{ row }">
              <span>{{ row.LineAbortEmpName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="中止时间" min-width="100px">
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toDateString(row.LineAbortDate) }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="需求日期" min-width="180px">
            <template slot-scope="{ row }">
              <span v-if="ReviewStatus">{{
                $commonJs.toDateString(row.DemandDate)
              }}</span>
              <el-date-picker
                v-else
                v-model="row.DemandDate"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
                style="width: 140px"
                @change="changeDeliveryDate(row)"
              >
              </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column
            align="right"
            label="累计执行数量"
            min-width="120px"
          >
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(getQuantity(row.ExecutionQuantity) )  }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="right"
            label="累计执行数量2"
            min-width="130px"
          >
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(getQuantity(row.ExecutionQuantity2) ) }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" label="销售订单号" min-width="180px">
            <template slot-scope="{ row }">
              <span>{{ row.OrderNo }}</span>
            </template>
          </el-table-column> -->
          <el-table-column align="left" label="来源单据" min-width="100px">
            <template slot-scope="{ row }">
              <span>{{ row.SourceType }}</span>
              <!-- <span v-if="row.SourceType === 1">销售订单</span>
              <span v-if="row.SourceType === 2">请购单</span> -->
            </template>
          </el-table-column>
          <el-table-column align="left" label="来源单号" min-width="180px">
            <template slot-scope="{ row }">
              <span>{{ row.SourceDocNo }}</span>
            </template>
          </el-table-column>
          <el-table-column align="right" label="现存量">
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(getQuantity(row.StockQuantity) ) }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="操作" v-if="!ReviewStatus">
            <template slot-scope="{ row, $index }">
              <el-button
                v-if="$permission.canWrite('/business/purchase/inquiry')"
                type="text"
                @click.stop="delTableList(row, $index)"
                >删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <!--  -->
      <el-row>
        <el-form-item label="审核人:" label-width="80px" style="width: 190px">
          {{ data.ReviewEmpName }}
        </el-form-item>
        <el-form-item label="审核时间:" label-width="80px" style="width: 190px">
          {{ $commonJs.toDateString(data.ReviewDate) }}
        </el-form-item>
        <el-form-item label="变更人:" label-width="80px" style="width: 190px">
          {{ data.UpdateUserName }}
        </el-form-item>
        <el-form-item label="变更日期:" label-width="80px" style="width: 190px">
          {{ $commonJs.toDateString(data.UpdateTime) }}
        </el-form-item>
      </el-row>
    </el-form>
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    <order-dialog ref="orderDialog" in-dialog @save="initerPrice" />
    <tradeunit-dialog
      ref="tradeunitDialog"
      in-dialog
      selectable
      @select="setTradeunit"
    />
    <print-dialog
      ref="printDialog"
      :columns="columns"
      :data="columnData"
      :form-data="formData"
    ></print-dialog>
  </div>
</template>
<script>
import VueBarcode from "vue-barcode";
import curdMixins from "@/mixins/trend/curd";
import empDialog from "@/components/personnel/result/record/listDialog";
import orderDialog from "@/components/business/purchase/inquiry/priceDialog";
import printDialog from "@/components/common/printDialog/printDialog";
import accountSelect from "@/components/business/purchase/select";
// import list from "@/components/business/purchase/inquiry/list";
import saleList from "@/data/business/sales/sale/edit/list.json";
import optionMixins from "@/mixins/option";
import settle from "@/components/basedata/finance/settle/select";
import tradeunitDialog from "@/components/basedata/business/come/listDialog";
// import invoiceSelect from "@/components/basedata/finance/invoice/select";
// import wmsSelect from "@/components/basedata/basedoc/wms/select";
// import businessSelect from "@/components/basedata/basedoc/business/select";
export default {
  name: "editInquiry",
  mixins: [curdMixins, optionMixins],
  components: {
    // list,
    empDialog,
    orderDialog,
    accountSelect,
    VueBarcode,
    printDialog,
    settle,
    tradeunitDialog,
    // invoiceSelect,
    // wmsSelect,
    // businessSelect,
  },
  data() {
    return {
      rtyList: [],
      propertyApi: require("@/api/ba/property").default,
      sourceTypeApi: require("@/api/ba/sourceType").default,
      api: require("@/api/pu/puPredictOrder").default,
      pdApi: require("@/api/ba/product").default,
      tradeUnitApi: require("@/api/ba/tradeUnit").default,
      transportApi: require("@/api/ba/transport").default,
      code_api: require("@/api/sy/serialCode").default,
      initDAccount: [],
      initTotal: 0,
      formData: [],
      columnkey: [],
      columns: [],
      columnData: [],
      colorList: [],
      DAccount: [],
      propertyList: [],
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      data: {
        OrderId: 0,
        OrderNo: "",
        OrderDate: "",
        ClerkId: 0,
        Remark: "",
        Amount: 0,
        NoTaxAmount: 0,
        TaxAmount: 0,
        RemainAmount: 0,
        DisposeTax: 0,
        Status: 0,
        AddTime: "",
        Address: "",
        UpdateTime: "",
        AddUserId: 0,
        UpdateUserId: 0,
        DemandId: 0,
        ClerkName: "",
        DemandDate: "",
        ReviewEmpId: 0,
        ReviewDate: "",
        ReviewEmpName: "",
        PredictType: 0,
        MakeEmpId: 0,
        MakeDate: "",
        MakeEmpName: "",
        Products: [],
      },
      isMainUnitId2: false,
      Mode: 0,
      isSave: false,
      tabPosition: "",
      reach: "联查",
      handledBy: "",
      preparedBy: "",
      IsGift: false,
      service: null,
      is_orderUpdateStatus: false,
      productList: [],
      tradeUnitList: [],
      transportList: [],
      tableList: [],
      optionList: [],
      tableColorShow: true,
      currentRow: null,
      currentIndex: 0,
      rules: {
        OrderDate: [
          { required: true, message: "单据日期不能为空", trigger: "blur" },
        ],
        OrderNo: [
          { required: true, message: "单据编码不能为空", trigger: "blur" },
        ],
        TradeUnitId: [
          { required: true, message: "供应商不能为空", trigger: "change" },
        ],
        Address: [
          { required: true, message: "到货地址不能为空", trigger: "blur" },
        ],
        TransportId: [
          { required: true, message: "运输方式不能为空", trigger: "blur" },
        ],
        ClerkId: [
          { required: true, message: "经手人不能为空", trigger: "blur" },
        ],
        Remark: [{ required: true, message: "备注不能为空", trigger: "blur" }],
      },
      option: {
        // 换算率
        Iinvexchrate: 0,
        //数量
        Quantity: 0,
        //数量舍零
        IsQuantityRounding: true,
        // 单价整数
        UnitPrice: 0,
        // 单价小数
        UnitPriceDecimals: 0,
        // 单价舍零
        IsUnitPriceRounding: true,
      },
    };
  },
  computed: {
    orderUpdateStatus() {
      return this.data.Status == 2 && !this.is_orderUpdateStatus ? true : false;
    },
    ReviewName() {
      return this.data.Status == 2 ? "弃审" : "审核";
    },
    isLineAbort() {
      return this.data.OrderId > 0 && this.data.Products.length > 0
        ? false
        : true;
    },
    ReviewStatus() {
      return this.data.Status == 2 ? true : false;
    },
    canPrice() {
      return this.$permission.canPrice("/business/purchase/inquiry");
    },
    canWrite() {
      return this.$permission.canWrite("/business/purchase/inquiry");
    },
    canReview() {
      return this.$permission.canReview("/business/purchase/inquiry");
    },
  },

  mounted() {
    this.init();
    // this.api.list({}).then((res) => (this.productList = res.Data));
    if (this.$route.params.isSave) this.isSave = true;
    if (this.$route.params.mode == "create" || !this.$route.params.mode) {
      this.createOrder();
    }
    console.log("触发编辑");
    if (this.$route.params.mode == "edit") {
      this.editOrder(this.$route.params.data.OrderId);
    }
    if (this.$route.params.mode == "details") {
      this.editOrder(this.$route.params.data.OrderId);
    }
  },
  methods: {
    async goJump(index) {
      let params = {};
      switch (index) {
        case 1: //采购订单引用请购单。sourceType为请购单
          params.SourceDocId = this.data.OrderId;
          const res = await this.sourceTypeApi.info("请购单");
          params.SourceType = res.SourceTypeId;
          this.$router.push({ name: "emptor", params: params });
          break;
        case 2:
          params.DemandId = this.data.DemandId;
          this.$router.push({ name: "demand", params: params });
          break;
        case 3:
          console.log("this.data", this.data);
          params.OrderNo = this.data.Products[0].SaOrderNo;
          console.log("  params.OrderNo", params.OrderNo);
          // params.SourceType=1
          this.$router.push({ name: "saleorder", params: params });
          break;
      }
    },
    initerPrice(price) {
      this.currentRow.Price = price;
      this.changePrice(this.currentRow, this.currentIndex);
    },
    onInsert(e) {
      let { type, index } = e;

      this.interpolate(null, index, type);
    },
    editT(row) {
      if (row.T !== 0) {
        row.T = 1;
      }
    },
    interpolate(row, index, type = "") {
      let o = {
        T: 0,
        StockQuantity: 0,
        ExistQuantity: 0,
        OrderProductId: 0,
        OrderId: 0,
        BarCode: "",
        ProductId: 0,
        UnitId: 0,
        Quantity: 0,
        Offer: null,
        Discount: 0,
        TaxRate: 0,
        Price: 0,
        BatchNo: "",
        ProductionDate: "",
        ExpirationDate: "",
        TaxAmount: 0,
        Amount: 0,
        ColorId: 0,
        LineAbortEmpId: 0,
        LineAbortDate: "",
        LineAbort: 0,
        DemandDate: "",
        PurchaseDemandId: 0,
        PurchaseDemandDetailId: 0,
        ProductNo: "",
        ProductSpec: "",
        ColorName: "",
        UnitName: "",
        SourceDocNo: "",
        SourceType: "",
        UnitId2: 0,
        Quantity2: 0,
        ExecutionQuantity: 0,
        ExecutionQuantity2: 0,
        Unit2Name: "",
        TaxPrice: 0,
        TaxLimit: 0,
        DiscountAmount: 0,
        Rate: 0,
        ProductName: "",
        TradeUnitId: 0,
        TradeUnitNo: "",
        TradeUnitName: "",
      };
      if (type == "down") {
        index = index + 1;
      }
      this.tableList.splice(index, 0, o);
      let copy = JSON.parse(JSON.stringify(this.tableList));
      this.tableList = [];
      this.$nextTick(() => {
        this.tableList = copy;
      });
    },
    setTradeunit(data) {
      this.currentRow.TradeUnitId = data.TradeUnitId;
      this.currentRow.TradeUnitName = data.FullName;
      this.currentRow.TradeUnitNo = data.TradeUnitNo;
      if (this.currentRow.T !== 0) {
        this.currentRow.T = 1;
      }
    },
    openTradeunit(row) {
      this.currentRow = row;
      this.$refs.tradeunitDialog.open().then((that) => {
        that.getData({ TradeUnitTypes: [1, 2] });
        // that.getData();
      });
    },
    clearTradeUnit(row) {
      row.TradeUnitId = 0;
      row.TradeUnitName = "";
      row.TradeUnitNo = "";
      row.T = 1;
    },
    previewNo(time = "") {
      this.code_api.previewNo("请购单", time).then((res) => {
        // console.log("serialType", res);
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.OrderNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取请购单编码失败");
        }
      });
    },
    // 属性切换
    changeProperty(val, row) {
      if (row.T !== 0) {
        row.T = 1;
      }

      let item = this.propertyList.filter((item) => {
        return item.PropertyId === val;
      })[0];

      row.PropertyName = item.PropertyName;
    },
    init() {
      this.propertyApi
        .list({
          Status: 1,
        })
        .then((res) => {
          if (res.Code === 0) {
            this.propertyList = res.Data;
          }
        });

      this.callOptionApi();
      this.tradeUnitApi.list({ TradeUnitTypes: [1, 2] }).then((res) => {
        if (res.Code == 0) this.tradeUnitList = res.Data;
      });
      this.transportApi.list({}).then((res) => {
        if (res.Code == 0) this.transportList = res.Data;
      });
      this.pdApi
        .list({ Property: "采购", pageIndex: 1, pageSize: 7, Status: 1, })
        .then((res) => {
          this.DAccount = res.Data;
          this.initDAccount = res.Data;
          this.listTotal = res.Count;
          this.initTotal = res.Count;
        });
    },
    createOrder() {
      const user = this.$store.state.user;
      if (user) {
        this.data.ClerkId = user.empId;
        this.data.ClerkName = user.name;
        this.data.MakeEmpId = user.id;
        this.data.MakeEmpName = user.name;
      }

      this.data.MakeDate = this.$commonJs.getToday();
      this.data.OrderDate = this.$commonJs.getToday();
      this.data.AddTime = this.$commonJs.getToday();
      this.addList();
      this.previewNo();
    },
    editOrder(data, type = 0) {
      console.log("执行编辑", data);
      this.api.info({ Id: data, IsRemoveOccupy: false }).then((res) => {
        if (res.Code === 0) {
          this.isSave = true;
          this.data = res.Data;
          this.tableList = res.Data.Products?.map(
            (item) => ((item.T = 3), item)
          );

          this.tableList.forEach(item => {
            if(item.Units.length === 0){
              item.UnitType = 0
            }else{
              item.UnitType = 1
              let UnitItem = item.Units.filter((v) => {
                return item.UnitId === v.UnitId;
              })[0];
              console.log('UnitItem', UnitItem)

              item.IsMain = UnitItem.IsMain;
              item.ChangeType = 0;
              item.Units.forEach(v=>{
                if(v.ChangeType==1)item.ChangeType=v.ChangeType
              })
             
            }
          })

          if(type === 1){
            this.Review()
          }
        }
        if (res.Data.Products.length == 0) this.addList();
      });
    },
    toggleOrder() {
      this.$refs.saleQuotationSelect.open();
    },

    resetFun() {
      this.pageParams.pageIndex = 1;
      this.DAccount = this.initDAccount;
      this.listTotal = this.initTotal;
    },
    currentPage({val, text1}, row) {
      this.pageParams.pageIndex = val;
      this.pdApi
        .list({ Property: "采购", pageIndex: val, pageSize: 7, Status: 1, ProductName: text1})
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;
            this.listTotal = res.Count;
          }
        });
    },
    inputText(text, row) {
      row.ProductName = text;
      this.pdApi
        .list({
          Property: "采购",
          // ProcessStage: 0,
          pageIndex: 1,
          pageSize: 7,
          Status: 1,
          ProductName: text,
        })
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;
            this.listTotal = res.Count;
          }
        });
    },
    setProduct(row, index) {
      let data = this.productList.filter(
        (item) => item.ProductId === row.ProductId
      );
      this.tableList[index].ProductName = data[0].ProductName;
      this.tableList[index].ProductNo = data[0].ProductNo;
      this.tableList[index].ProductSpec = data[0].ProductSpec;
      this.tableList[index].UnitName = data[0].PuUnitName;
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    // 选择存货名称
    onSelect(e, row) {
      console.log("e", e);
      row.UseProcess = e.UseProcess;
      let Product = this.tableList.map((i) => i.ProductId);

      if (Product.includes(e.ProductId))
        return this.$message.warning("产品已存在");

      if (row.T === 3 && row.ProductId !== e.ProductId) row.T = 1;
      row.ProductNo = e.ProductNo;
      row.ProductName = e.ProductName;
      row.ProductId = e.ProductId;
      row.ProductSpec = e.ProductSpec;
      // row.UnitId = e.PuUnitId;
      row.ExistQuantity = e.ExistQuantity;
      row.StockQuantity = e.StockQuantity;
      row.UnitId2 = e.UnitId2;
      row.ColorId = null;
      row.UnitType = 0;
      row.TradeUnitId = null;
      row.TradeUnitNo = "";
      row.TradeUnitName = "";
      row.UseColor = e.UseColor;
      row.Colors = e.Colors;
      row.Units = e.Units;
      row.UnitId = e.PuUnitId;
      row.UnitName = e.PuUnitName;
      // row.SaUnitId = e.PuUnitId;
      // row.SaUnitName = e.PdUnitName;
      row.ChangeType = 0;
      // console.log('row', JSON.parse(JSON.stringify(row)))
      // let _colorShow=e.find(item=>item.UseColor)
      // console.log(_colorShow,'colorShow')
      // this.colorList = e.Colors;
      this.optionList = e.Units;
      // console.log("Quantity", Number(row.Quantity));
      if (!Number(row.Quantity)) row.Quantity = 0;
      // if (e.UnitType === 0) {
      //   row.UnitId2 = e.SaUnitId;
      //   row.UnitName2 = e.PuUnitName;
      // }

      //
      if (e.Units.length === 0) {
        row.UnitId = e.PuUnitId;
        row.UnitName = e.PuUnitName;
        row.UnitId2 = 0;
        row.UnitName2 = "";
        row.Rate = 0;
        row.Quantity2 = 0;
      } else {
        row.UnitType = 1;
        e.Units.forEach((item) => {
            if (item.ChangeType == 1) row.ChangeType = item.ChangeType;
          });
        // 单位Id有值
        if (row.UnitId) {
          let index = this.getUnitIndex(3, e.Units, row.UnitId);
          let data = this.getUnitValue(e.Units, index);
          let assistIndex = 0;
          let assistData = {};
          row.IsMain = data.IsMain;
          // e.Units.forEach((item) => {
          //   if (item.ChangeType == 1) row.ChangeType = item.ChangeType;
          // });
          if (data.IsMain) {
            assistIndex = this.getUnitIndex(2, e.Units);
            assistData = this.getUnitValue(e.Units, assistIndex);
            row.Rate = parseFloat(this.getIinvexchrate(assistData.Rate));
          } else {
            assistIndex = this.getUnitIndex(1, e.Units);
            assistData = this.getUnitValue(e.Units, assistIndex);
            row.Rate = parseFloat(this.getIinvexchrate(data.Rate));
          }
          row.UnitId2 = assistData.UnitId;
          row.UnitName2 = assistData.UnitName;
        }else{
          let untiLength = e.Units.length;
          let mainData = [];
          let noMainData = [];
          for(let i = 0; i < untiLength; ++i){
            if(e.Units[i].IsMain){
              mainData.push(e.Units[i])
            }else{
              noMainData.push(e.Units[i])
            }
          }
          row.UnitId = mainData[0].UnitId;
          row.UnitName = mainData[0].UnitName;
          row.UnitId2 = noMainData[0].UnitId;
          row.UnitName2 = noMainData[0].UnitName;
          row.Rate = parseFloat(this.getIinvexchrate(noMainData[0].Rate));
          row.IsMain = true;
        }
        if (row.IsMain) {
          row.Quantity2 = this.getQuantity(row.Quantity / Number(row.Rate));
        } else {
          row.Quantity2 = this.getQuantity(row.Quantity * Number(row.Rate));
        }
        row.Amount = Number(row.Price ?? 0) * Number(row.Quantity ?? 0);
        row.TaxAmount = Number(row.Amount ?? 0) + Number(row.TaxLimit ?? 0);
      }

      // if (e.Units.length > 0) {
      //   const UnitIds = e.Units.map((i) => i.UnitId);
      //   const index =
      //     UnitIds.indexOf(e.SaUnitId) === e.Units.length
      //       ? 0
      //       : UnitIds.indexOf(e.SaUnitId) + 1;
      //   // row.UnitId2 = UnitIds[index];
      //   const saleData = e.Units.filter((i) => i.UnitId === e.SaUnitId)[0];
      //   const unitData = e.Units.filter((i) => i.UnitId === UnitIds[index])[0];
      //   // row.Rate = unitData.Rate / saleData.Rate;
      //   // row.Quantity2 = (row.Quantity / row.Rate).toFixed(2);
      //   row.UnitChangeType = unitData.ChangeType;
      // }
      // let _colorShow = this.tableList.find((item) => item.UseColor == true);
      // if (_colorShow) {
      //   this.tableColorShow = true;
      // } else {
      //   this.tableColorShow = false;
      // }
    },
    RateChange(data, row, index) {
      if (data < 0 || data == "") return;
      if (row.T === 3) row.T = 1;
      this.changeQuantity(this.tableList[index].Quantity, row, index);
    },
    compareSaUnit(data, row, index) {
      if (row.T === 3) row.T = 1;
      this.tableList[index].IsMain = data.IsMain;
      let findIndex = 0;
      if (row.UnitId == row.UnitId2) {
        let num = 0;
        num = row.Quantity;
        row.Quantity = row.Quantity2;
        row.Quantity2 = num;
        if (data.IsMain) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableList[index].Units);
          this.changeRightUnitId(index, findIndex);
        } else {
          findIndex = this.getUnitIndex(1, this.tableList[index].Units);
          this.changeRightUnitId(index, findIndex);
        }
      } else {
        if (data.IsMain) {
          findIndex = this.getUnitIndex(2, this.tableList[index].Units);
          this.changeRightUnitId(index, findIndex);
        } else {
          findIndex = this.getUnitIndex(1, this.tableList[index].Units);
          this.changeRightUnitId(index, findIndex, data.Rate);
        }
      }
      this.changeQuantity(this.tableList[index].Quantity, row, index);
    },
    //传入数组 索引 返回对应的 id 和name index是table索引  findIndex 是当前主辅单位索引
    changeRightUnitId(index, findIndex, Rate = 0) {
      this.tableList[index].UnitId2 =
        this.tableList[index].Units[findIndex].UnitId;
      this.tableList[index].UnitName2 =
        this.tableList[index].Units[findIndex].UnitName;
      if (Rate > 0) {
        this.tableList[index].Rate = parseFloat(this.getIinvexchrate(Rate));

      }
    },
    changeQuantity2(data, row, index) {
      if (data < 0 || data == "") return;
      if (row.T === 3) row.T = 1;
      data = this.getQuantity(data)
      row.Quantity2 = data;
      if (row.Units.length > 0) {
        if (row.IsMain == false) {
          if (row.ChangeType == 1) {
            if (row.Quantity === "" || row.Quantity === 0) return;
            row.Rate = parseFloat(this.getIinvexchrate(data / row.Quantity)); 
          } else {
            console.log("数量1=数量2/换算率");
            row.Quantity = this.getQuantity(data / row.Rate);
          }
        } else {
          if (row.ChangeType == 1) {
            if (row.Quantity === "" || row.Quantity === 0) return;
            row.Rate = parseFloat(this.getIinvexchrate(row.Quantity / data));
          } else {
            console.log("数量1=数量2*换算率");
            row.Quantity = this.getQuantity(data * row.Rate);
          }
        }
      } else {
        row.Quantity = data;
      }
    },
    getChangeQuantity(data, row, index) {
      if (row.Quantity === "" || row.Quantity === 0) {
        if (row.Quantity2 && row.Rate) {
          if (row.IsMain) {
            row.Quantity = this.getQuantity(row.Quantity2 * Number(row.Rate));
          } else {
            row.Quantity = this.getQuantity(row.Quantity2 / Number(row.Rate));
          }
        }
      }
    },
    getUnitValue(arr, findIndex) {
      let data = {};
      data.UnitId = arr[findIndex].UnitId;
      data.UnitName = arr[findIndex].UnitName;
      data.IsMain = arr[findIndex].IsMain;
      data.ChangeType = arr[findIndex].ChangeType;
      data.Rate = arr[findIndex].Rate;
      return data;
    },
    //获取计量单位主辅单位的索引
    getUnitIndex(type, arr, id = "") {
      let index = 0;
      if (type == 1) {
        //获取主单位索引
        index = arr.findIndex((el) => el.IsMain == true);
      } else if (type == 2) {
        //获取数组第一个不是主单位的索引
        index = arr.findIndex((el) => el.IsMain == false);
      } else {
        //获取当前传入id的索引
        index = arr.findIndex((el) => id == el.UnitId);
      }
      return index;
    },
    changeLeftUnitId(index, findIndex, Rate = 0) {
      this.tableList[index].UnitId =
        this.tableList[index].Units[findIndex].UnitId;
      this.tableList[index].SaUnitName =
        this.tableList[index].Units[findIndex].UnitName;
      if (Rate > 0) {
        this.tableList[index].Rate = parseFloat(this.getIinvexchrate(Rate));;
      }
    },
    compareUnitId(data, row, index) {
      if (row.T === 3) row.T = 1;
      if (data.IsMain) {
        this.tableList[index].IsMain = false;
      } else {
        this.tableList[index].IsMain = true;
      }
      let findIndex = 0;
      if (row.UnitId == row.UnitId2) {
        let num = 0;
        num = row.Quantity;
        row.Quantity = row.Quantity2;
        row.Quantity2 = num;
        if (this.tableList[index].IsMain == false) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableList[index].Units);
          this.changeLeftUnitId(index, findIndex);
        } else {
          findIndex = this.getUnitIndex(1, this.tableList[index].Units);
          this.changeLeftUnitId(index, findIndex);
        }
      } else {
        if (this.tableList[index].IsMain == false) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableList[index].Units);
          this.changeLeftUnitId(index, findIndex);
        } else {
          findIndex = this.getUnitIndex(1, this.tableList[index].Units);
          this.changeLeftUnitId(index, findIndex, data.Rate);
        }
      }
      this.changeQuantity2(this.tableList[index].Quantity2, row, index);
    },
    addColumn(row, column) {
      if (row.index === this.tableList.length - 1 && !this.ReviewStatus) {
        this.addList();
      }
    },
    // compareUnitId(data, row, index) {
    //   console.log("data", data);

    //   this.isMainUnitId2 = true;
    //   this.tableList[index].Rate = data.UnitId === row.SaUnitId ? 1 : data.Rate;
    //   row.UnitChangeType = data.ChangeType;
    //   if (data.ChangeType === 0) row.Quantity2 = row.Quantity * row.Rate;
    //   if (data.ChangeType === 1 && Number(row.Quantity2) != 0)
    //     row.Rate = row.Quantity2 / row.Quantity;
    // },
    changeDeliveryDate(row) {
      if (row.T === 3) row.T = 1;
    },
    changeIsGift(data, row) {
      if (row.T === 3) row.T = 1;
      if (data) {
        row.Offer = 0;
        row.Discount = 0;
        row.TaxRate = 0;
        row.Price = 0;
        row.TaxPrice = 0;
        row.Amount = 0;
        row.TaxLimit = 0;
        row.TaxAmount = 0;
        row.DiscountAmount = 0;
      }
    },
    RestartOrder() {
      this.$message.success("新增");
      Object.assign(this.$data, this.$options.data.call(this));
      this.init();
      this.createOrder();
      this.addList();

      setTimeout(() => {
        this.$refs.ruleForm.clearValidate();
      }, 30);
    },

    orderUpdate() {
      this.$message.success("变更");
      this.is_orderUpdateStatus = true;
    },
    Review(){
      this.api.review(this.data.OrderId).then((res) => {
        this.data.Status = 2;
        res.Code === 0
          ? this.$message.success(res.Msg)
          : this.$message.warning(res.Msg);

        if (res.Code === 0) {
          this.editOrder(this.data.OrderId);
          // this.api.info(this.data.OrderId).then((res) => {
          //   this.data = res.Data;
          // });
        }
      });
    },
    orderReview() {
      if (this.data.OrderId == 0) {
        this.$message.warning("订单未保存");
        return;
      }
      const message =
        this.data.Status == 2 ? "确认要弃审吗？ " : "确认提交审核吗？";
      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const data = this.data.Status == 2 ? "back" : "review";
          if(data === 'review'){
            this.save(1);
          }else if(data === 'back'){
            this.api[data](this.data.OrderId).then((res) => {
              if (res.Code === 0 && data == "review") {
                this.data.Status = 2;
              }
              if (res.Code === 0 && data == "back") this.data.Status = 0;
              res.Code === 0
                ? this.$message.success(res.Msg)
                : this.$message.warning(res.Msg);

              if (res.Code === 0) {
                this.editOrder(this.data.OrderId);
                // this.api.info(this.data.OrderId).then((res) => {
                //   this.data = res.Data;
                // });
              }
            });
          }
          // let ids = rows.map((item) => {
          //   return item.BusinessTypeId;
          // });
          // this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
    orderDel() {
      // let rows = this.$refs.list.getCheckedRows();
      if (this.data.OrderId == 0) {
        this.$message.warning("订单未保存");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.api.delete({ Id: this.data.OrderId }).then((res) => {
            if (res.Code === 0) this.RestartOrder();
            res.Code === 0
              ? this.$message.success(res.Msg)
              : this.$message.warning(res.Msg);
          });
          // let ids = rows.map((item) => {
          //   return item.BusinessTypeId;
          // });
          // this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
    delTableList(data, index) {
      // this.$message.success("删除");
      this.tableList.splice(index, 1);
      if (this.tableList.length === 0) this.addList();
    },
    openEmp() {
      this.$refs.empDialog.open().then((that) => {
        that.getData();
      });
    },
    setEmp(data) {
      console.log(data);
      this.data.ClerkId = data.EmpId;
      this.data.ClerkName = data.EmpName;
      this.data.DpId = data.DpId;
      this.data.DpName = data.DpName;
      this.data.DpNo = data.DpNo;
    },

    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.PropertyId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
    openSales(row, index) {
      this.currentRow = row;
      this.currentIndex = index;
      let ProductName = row.ProductName;
      let TradeUnitName = row.TradeUnitName;

      this.$refs.orderDialog.open().then((that) => {
        that.setData(ProductName, TradeUnitName);
      });
    },
    changeTradeUnit(data) {
      this.data.TradeUnitName = data.TradeUnitName;
      this.data.TradeUnitClassName = data.TradeUnitClassName;
      this.data.TradeUnitType = data.TradeUnitType;
    },
    // 貌似需要审核后才可以进行 修改 行中止
    changeLineAbort(data, row) {
      if (this.data.OrderId == 0 || row.ProductId == 0)
        return (row.LineAbort = false);

      this.api
        .lineAbort({
          Id: row.OrderProductId,
          IsLineAbort: data,
        })
        .then((res) => {
          if (res.Code === 1) {
            row.LineAbort = !data;
            return this.$message.error(res.Msg);
          }
        });
    },
    openDialog(type) {
      if (type === "销售订单") {
        this.title = "销售订单";
        this.bool = true;
        this.$refs.saleOrderSelect.open();
      } else {
        this.title = "销货单列表";
        this.bool = false;
        this.$refs.deliveryReleaseSelect.open();
      }
    },
    changeColor(row, index) {
      if (row.T === 3) this.tableList[index].T = 1;
    },
    changeTradeUnitRow(val, row, index) {
      console.log("---val---", val);
      if (row.T === 3) {
        this.tableList[index].T = 1;
      }
      let item = this.tradeUnitList.filter((item) => {
        return val === item.TradeUnitId;
      })[0];
      console.log("---item--", item);

      this.tableList[index].TradeUnitId = val;
      this.tableList[index].TradeUnitName = item.FullName;
      this.tableList[index].TradeUnitNo = item.TradeUnitNo;
      console.log("---row--", row);
    },
    validInput(row, index, type) {
      if (row.T === 3) this.tableList[index].T = 1;
      if (!Number(row.Quantity)) {
        this.$message.warning("请先填写数量");
        return true;
      }
      return false;
    },

    changeQuantity(data, row, index) {
      // data = parseFloat(data)
      // row.Quantity = parseFloat(row.Quantity);
      if (data < 0) return;
      if (row.T == 3) this.tableList[index].T = 1;
      data = parseFloat(this.getQuantity(data));
      row.Quantity = data;
      if (row.Units.length > 0) {
        if (row.IsMain) {
          row.Quantity2 = this.getQuantity(row.Quantity / row.Rate);
        } else {
          row.Quantity2 = this.getQuantity(row.Quantity * row.Rate);
        }
      } else {
        row.Quantity2 = row.Quantity;
      }


      // if (this.optionList.length === 0) row.Quantity2 = Number(row.Quantity);
      // if (this.optionList.length > 0 && row.UnitId2 != 0) {
      //   const mainList = this.optionList
      //     .filter((i) => i.IsMain)
      //     .map((sub) => sub.UnitId);
      //   if (mainList.includes(row.SaUnitId) && this.isMainUnitId2 == false)
      //     row.Quantity2 = row.Quantity / row.Rate;
      //   else if (!mainList.includes(row.SaUnitId) && this.isMainUnitId2 == true)
      //     row.Quantity2 = row.Quantity * row.Rate;
      //   else row.Quantity2 = Number(row.Quantity);
      // } else row.Quantity2 = Number(row.Quantity);
     // 金额
     if (Number(row.Price) ) {
        let Amount = Number(row.Price) * data * (Number(row.Discount ?? 0) / 100);
        this.tableList[index].Amount = Number(Amount.toFixed(2));
      }

       // 税额
     if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxLimit = Number(row.Price) * data * (Number(row.TaxRate) / 100);
        this.tableList[index].TaxLimit = Number(TaxLimit.toFixed(2));
      }

      // 含税单价
      if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxPrice = Number(row.Price) * (100 + Number(row.TaxRate) ) / 100;
        this.tableList[index].TaxPrice = this.getPrice(TaxPrice);
      }

      // 含税金额
      if (Number(row.Amount) || Number(row.TaxLimit)) {
        let TaxAmount = Number(row.Amount ?? 0)   + Number(row.TaxLimit ?? 0);
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
      }

     
      
      // 折扣金额
      if (Number(row.Offer) && Number(row.Price)) {
        let DiscountAmount = (Number(row.Offer) - Number(row.Price))  * Number(data);
        this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2));
      }

    },
    // 数量2
    // changeQuantity2(row, index) {
    //   console.log("输出", row.UnitChangeType);
    //   if (this.optionList.length === 0) return (row.Quantity = row.Quantity2);
    //   if (this.optionList.length > 0) {
    //     if (row.UnitChangeType == 0) {
    //       console.log("执行");
    //       row.Quantity = row.Quantity2 / row.Rate;
    //       return this.changeQuantity(row.Quantity, row, index);
    //     }
    //     if (row.UnitChangeType == 1) {
    //       return (row.Rate = row.Quantity2 / row.Quantity);
    //     }
    //   }
    // },
    // 报价
    changeOffer(row, index) {
      // row.Offer = parseFloat(row.Offer)
      if (row.T === 3) this.tableList[index].T = 1;
      // 修改单价
      let Price = (row.Discount / 100) * row.Offer  
      this.tableList[index].Price = Price < 0 ? 0 : this.getPrice(Price);

      //修改金额
      let Amount = Number(row.Price ?? 0) * Number(row.Quantity ?? 0);
      this.tableList[index].Amount = Number(Amount.toFixed(2));

      //修改含税单价
      if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxPrice = Number(row.Price) * (100 + Number(row.TaxRate) ) / 100;
        this.tableList[index].TaxPrice = this.getPrice(TaxPrice);
      }

      // 折扣金额
      if (Number(row.Offer) && Number(row.Price)) {
        let DiscountAmount = (Number(row.Offer) - Number(row.Price))  * Number(row.Quantity);
        this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2));
      }

      // 税额
     if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxLimit = Number(row.Price) * Number(row.Quantity) * (Number(row.TaxRate) / 100);
        this.tableList[index].TaxLimit = Number(TaxLimit.toFixed(2));
      }

      // 含税金额
      if (Number(row.Amount) || Number(row.TaxLimit)) {
        let TaxAmount = Number(row.Amount ?? 0)  + Number(row.TaxLimit ?? 0);
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
      }
    },
    // 折扣
    changeDiscount(row, index) {
      if (this.validInput(row, index, "Discount")) return;
      if (row.T == 3) this.tableList[index].T = 1;
      // 修改单价
      let Price = (row.Discount / 100) * row.Offer  
      this.tableList[index].Price = Price < 0 ? 0 : this.getPrice(Price);

      
       //修改金额
       let Amount = Number(row.Price ?? 0) * Number(row.Quantity ?? 0);
      this.tableList[index].Amount = Number(Amount.toFixed(2));

      //修改含税单价
      if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxPrice = Number(row.Price) * (100 + Number(row.TaxRate) ) / 100;
        this.tableList[index].TaxPrice = Number(this.getPrice(TaxPrice));
      }

      // 折扣金额
      if (Number(row.Offer) && Number(row.Price)) {
        let DiscountAmount = (Number(row.Offer) - Number(row.Price))  * Number(row.Quantity);
        this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2));
      }

      // 税额
     if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxLimit = Number(row.Price) * Number(row.Quantity) * (Number(row.TaxRate) / 100);
        this.tableList[index].TaxLimit = Number(TaxLimit.toFixed(2));
      }

      // 含税金额
      if (Number(row.Amount) || Number(row.TaxLimit)) {
        let TaxAmount = Number(row.Amount ?? 0)  + Number(row.TaxLimit ?? 0);
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
      }
    },
    // 单价
    changePrice(row, index) {
      if (this.validInput(row, index, "Price")) return;

      if (row.T == 3) this.tableList[index].T = 1;

      row.Price = this.getPrice(row.Price);

      let quantityNum = 0;
      if(row.Units.length === 0){
        quantityNum=row.Quantity
      }else{
        if(row.IsMain){
          quantityNum=row.Quantity
        }else{
          quantityNum=row.Quantity2
        }
      }
      row.quantityNum = quantityNum;
      let rate = null;

      if(row.Offer == 0 || row.Offer == null || row.Offer == ""){
        
        rate = this.tableList[index].Discount / 100;
        if(rate === 1){
          row.Offer = row.Price;
        }else{
          row.Offer = Number((row.Price * row.Discount).toFixed(2)) 
        }
      }else{ 
        rate = Number(row.Price) / Number(row.Offer)  * 100 
        this.tableList[index].Discount = Number((rate).toFixed(2)) ;
      }

      row.changeMode = 1;

      // 修改单价
      let equation = null;
      if(row.Discount == 100){
        equation = Number(row.Offer)
      }else{
        equation = row.Price
      }

      // 金额
      if (Number(row.quantityNum)) {
        console.log("row.quantityNum",row.quantityNum)
        let Amount = equation * Number(row.quantityNum) ;
        console.log("equation",equation)
        this.tableList[index].Amount = Number(Amount.toFixed(2));
      }

      // 修改含税单价
      let TaxPrice = equation * (100 + Number(row.TaxRate) ) / 100;
      this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : this.getPrice(TaxPrice);

      // this.changeDiscount(row, index);
      
      if (Number(row.Offer)) {
       // this.tableList[index].TaxPrice = Number(equation) < 0 ? 0 :  parseFloat(Number(equation).toFixed(2));
        // this.tableList[index].Price = equation < 0 ? 0 : equation.toFixed(2);

        // 折扣金额
        let DiscountAmount = 0;
        DiscountAmount = (row.Offer - equation)  * row.quantityNum;
          
        this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2));
        
      }
      if (Number(row.TaxRate)) {

        let TaxLimit = equation * row.quantityNum * (row.TaxRate / 100);
        this.tableList[index].TaxLimit = TaxLimit < 0 ? 0 : Number(TaxLimit.toFixed(2));
        // this.changeTaxRate(row, index);
      }
      
      if (Number(row.TaxLimit) || Number(row.Amount)) {
        let TaxAmount = Number(row.Amount) + Number(row.TaxLimit ?? 0);
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
      }
    },
    // 税率
    changeTaxRate(row, index) {
      if (this.validInput(row, index, "TaxRate")) return;
      if (row.T == 3) this.tableList[index].T = 1;

      row.TaxRate = parseFloat(this.getIinvexchrate(TaxRate))
      // 修改税额
      let TaxLimit = Number(row.Price ?? 0) * Number(row.Quantity) * ((row.TaxRate ?? 0) / 100)
      this.tableList[index].TaxLimit = Number(TaxLimit.toFixed(2));

      // 修改含税单价
      let TaxPrice = row.Price * (100 + Number(row.TaxRate) ) / 100;
      this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : this.getPrice(TaxPrice);
      
      // 含税金额
      let TaxAmount = Number(row.Amount ?? 0) + Number(row.TaxLimit ?? 0);
      this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));

    },
    // 含税单价
    changeTaxPrice(row, index) {
      if (this.validInput(row, index, "TaxPrice")) return;
      if (row.T == 3) this.tableList[index].T = 1;
      // 修改单价
      let Price = row.TaxPrice / (1+ row.TaxRate / 100)
      this.tableList[index].Price = this.getPrice(Price);

      // 修改折扣率
      let rate = Number(row.Price) / Number(row.Offer)  * 100 
      this.tableList[index].Discount = Number((rate).toFixed(2));

      // 修改金额
      let Amount = Number(row.Price) * Number(row.Quantity) * (row.Discount / 100) 
      this.tableList[index].Amount = Number(Amount.toFixed(2));

       // 折扣金额
      let DiscountAmount = 0;
      DiscountAmount = (row.Offer - Number(row.Price))  * row.Quantity;
      this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2));

      if (Number(row.TaxRate)) {

        let TaxLimit = Number(row.Price) * Number(row.Quantity) * (Number(row.TaxRate) / 100);
        this.tableList[index].TaxLimit = TaxLimit < 0 ? 0 : Number(TaxLimit.toFixed(2));
        // this.changeTaxRate(row, index);
      }

      if (Number(row.TaxLimit) || Number(row.Amount)) {
        let TaxAmount = Number(row.Amount) + Number(row.TaxLimit);
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
      }
    },
    // 税额
    changeTaxLimit(row, index) {
      if (this.validInput(row, index, "TaxLimit")) return;
      // if(Number(row.Quantity)) this.tableList[index].TaxAmount

      if (row.T == 3) this.tableList[index].T = 1;

      

      if(row.changeMode === 0 || row.changeMode == null){
        // 修改金额
        let Amount = Number(row.TaxAmount) - Number(row.TaxLimit);
        this.tableList[index].Amount = Number(Amount.toFixed(2));

        // 修改单价
        let Price = Number(row.Amount) / Number(row.Quantity)
        this.tableList[index].Price = this.getPrice(Price);

        // this.changePrice(row, index)

        // 修改折扣率
        let rate = Number(row.Price) / Number(row.Offer)  * 100 
        this.tableList[index].Discount = Number((rate).toFixed(2)) ;

        // 修改含税单价
        let TaxPrice = Number(row.Price) * (100 + Number(row.TaxRate ?? 0) ) / 100;
        this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : this.getPrice(TaxPrice);

        // 折扣金额
        let DiscountAmount = 0;
        DiscountAmount = (row.Offer - Number(row.Price))  * row.Quantity;
        this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2));

        // 修改含税金额
        if (Number(row.TaxLimit) || Number(row.Amount)) {
          let TaxAmount = Number(row.Amount) + Number(row.TaxLimit);
          this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
        }



      }else{
        // 修改含税金额
        let TaxAmount = Number(row.Amount) + Number(row.TaxLimit);
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));

        // 修改含税单价
        let TaxPrice = Number(row.TaxAmount) / Number(row.Quantity);
        this.tableList[index].TaxPrice = this.getPrice(TaxPrice);
      }
    },
    // 金额
    changeAmount(row, index) {
      if (this.validInput(row, index, "Amount")) return;
      if (row.T == 3) this.tableList[index].T = 1;

      // 修改单价
      let Price = Number(row.Amount) / Number(row.Quantity) 
      this.tableList[index].Price = this.getPrice(Price);

      // 修改报价
      if(Number(this.tableList[index].Discount) === 100){
        row.Offer = this.tableList[index].Price;
      }

      // 修改折扣率
      let rate = Number(row.Price) / Number(row.Offer)  * 100 
      this.tableList[index].Discount = Number((rate).toFixed(2));

       // 折扣金额
       let DiscountAmount = 0;
        DiscountAmount = (row.Offer - Number(row.Price)) * row.Quantity;
        this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2));

      // this.changePrice(row, index)
       // 修改含税单价
      if(Number(row.TaxRate)){
        let TaxPrice = Number(row.Price) * (100 + Number(row.TaxRate) ) / 100;
        this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : Number(this.getPrice(TaxPrice));
      }
      
      // 修改税额
      if (Number(row.TaxRate)) {

        let TaxLimit = Number(row.Price) * Number(row.Quantity) * (row.TaxRate / 100);
        this.tableList[index].TaxLimit = TaxLimit < 0 ? 0 : Number(TaxLimit.toFixed(2));
      // this.changeTaxRate(row, index);
      }

      // 修改含税金额
      if (Number(row.TaxLimit) || Number(row.Amount)) {
        let TaxAmount = Number(row.Amount) + Number(row.TaxLimit);
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
      }
    },
    // 含税金额
    changeTaxAmount(row, index) {
      if (this.validInput(row, index, "TaxAmount")) return;

      if (row.T == 3) this.tableList[index].T = 1;

      row.changeMode = 0;

      // 修改金额
      let Amount = Number(row.TaxAmount) - Number(row.TaxLimit)
      this.tableList[index].Amount = Number(Amount.toFixed(2));


      // 修改单价
      let Price = Number(row.Amount) / Number(row.Quantity)
      this.tableList[index].Price = this.getPrice(Price);

      // 修改折扣率
      let rate = Number(row.Price) / Number(row.Offer)  * 100 
      this.tableList[index].Discount = Number((rate).toFixed(2));

      // 修改含税单价
      let TaxPrice = Number(row.TaxAmount) / Number(row.Quantity)
      this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : this.getPrice(TaxPrice); 


       // 折扣金额
      let DiscountAmount = 0;
      DiscountAmount = (row.Offer - Number(row.Price))  * row.Quantity;
      this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2));

    },
    // 折扣金额
    changeDiscountAmount(row, index) {
      if (this.validInput(row, index, "DiscountAmount")) return;
      if (row.T == 3) this.tableList[index].T = 1;
      
      // 修改单价
      let Price = row.Offer - (row.DiscountAmount / row.Quantity)
      this.tableList[index].Price = this.getPrice(Price);

      // 修改折扣率

      let rate = Number(row.Price) / Number(row.Offer)  * 100 
      this.tableList[index].Discount = Number((rate).toFixed(2));

      // 金额
      let Amount = Number(row.Price) * Number(row.Quantity) * (Number(row.Discount) / 100);
      this.tableList[index].Amount = Number(Amount.toFixed(2));

      // 修改含税单价
      if(Number(row.TaxRate)){
        let TaxPrice = Number(row.Price) * (100 + Number(row.TaxRate) ) / 100;
        this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : this.getPrice(TaxPrice);
      }
      
      // 修改税额
      if (Number(row.TaxRate)) {

        let TaxLimit = Number(row.Price) * Number(row.Quantity) * (row.TaxRate / 100);
        this.tableList[index].TaxLimit = TaxLimit < 0 ? 0 : Number(TaxLimit.toFixed(2));
      // this.changeTaxRate(row, index);
      }

      // 修改含税金额
      if (Number(row.TaxLimit) || Number(row.Amount)) {
        let TaxAmount = Number(row.Amount) + Number(row.TaxLimit);
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
      }
    },
    // 单价弹窗
    renderHeader(h, { column }) {
      return h("div", [
        h("span", column.label),
        h("i", {
          class: "el-icon-s-order",
          style: "font-size:14px;cursor: pointer;",
          on: {
            click: this.openSales,
          },
        }),
      ]);
    },
    openPrint() {
      this.columnkey = saleList.Data.map((i) => i.tableName);
      this.columns = saleList.Data.reduce((acc, item) => {
        let print = { ...item.print, key: item.tableName, label: item.label };
        acc.push({ label: item.label, data: print });
        return acc;
      }, []);
      this.formData = saleList.Data.reduce((acc, item) => {
        return acc.concat({
          key: item.tableName,
          label: item.label,
          value: this.data[item.tableName],
        });
      }, []);
      this.$refs.printDialog.open();
      s;
    },
    save(type = 0) {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return false;
        const Product = JSON.parse(JSON.stringify(this.data.Products));
        const TableList = JSON.parse(JSON.stringify(this.tableList));
        // 清除没有产品的数据
        this.tableList = this.tableList.filter((i) => i.ProductId != 0);
        // if (this.tableList.filter((i) => i.UnitId2 == null).length > 0)
        //   return this.$message.warning("计量单位2不能为空");
        // if (this.tableList.filter((i) => i.Quantity == null).length > 0)
        //   return this.$message.warning("数量不能为空");
        // if (this.tableList.filter((i) => i.DemandDate == "").length !== 0)
        //   return this.$message.warning("交货日期不能为空");
        // //

        for (let i = 0; i <= this.tableList.length - 1; i++) {
          if (
            this.tableList[i].Quantity == null ||
            this.tableList[i].Quantity == 0
          )
            return this.$message.warning("数量不能为空并且不为0");
          if (
            this.tableList[i].UnitId2 == null &&
            this.tableList[i].UnitType == 1
          )
            return this.$message.warning("计量单位2不能为空");

          if (
            this.tableList[i].UseColor &&
            (this.tableList[i].ColorId === 0 ||
              this.tableList[i].ColorId == null)
          ) {
            this.$message.error(
              `存货${this.tableList[i].ProductName}未填写颜色`
            );
            return;
          }
          if (
            this.tableList[i].UseProcess &&
            (this.tableList[i].PropertyId === 0 ||
              this.tableList[i].PropertyId == null)
          ) {
            this.$message.error(
              `存货${this.tableList[i].ProductName}未填写属性`
            );
            return;
          }
        }
        if (this.data.Products.length > 0) {
          let delIds = this.tableList.map((item) => item.ProductId);
          let delList = this.data.Products.reduce((arr, item) => {
            if (!delIds.includes(item.ProductId)) arr.push({ ...item, T: 2 });
            return arr;
          }, []);

          let addIds = this.data.Products.map((item) => item.ProductId);
          let addList = [];
          addList = this.tableList.reduce((arr, item) => {
            if (!addIds.includes(item.ProductId)) arr.push({ ...item, T: 0 });
            return arr;
          }, []);

          let updateList = this.data.Products.filter((i) => i.T == 1);
          addList.forEach((item) => {
            item.ColorId = item.ColorId ? item.ColorId : 0;
            item.Offer = item.Offer ?? 0;
          });
          delList.forEach((item) => {
            item.ColorId = item.ColorId ? item.ColorId : 0;
            item.Offer = item.Offer ?? 0;
          });
          updateList.forEach((item) => {
            item.ColorId = item.ColorId ? item.ColorId : 0;
            item.Offer = item.Offer ?? 0;
          });
          this.data.Products = [...addList, ...delList, ...updateList];
        } else {
          this.data.Products = this.tableList;
        }

        //
        this.data.DemandDate = this.data.OrderDate;
        console.log("保存前", this.data);
        // var data = this.$commonJs.obj.removeNullKey(this.data);
        // this.data.Requirement = "";
        const sub = JSON.parse(JSON.stringify(this.data));
        // 等于空设置为0
        sub.Products.forEach((item) => {
          Object.keys(item).forEach((key) => {
            if (
              item[key] == null &&
              key !== "LineAbortDate" &&
              key !== "DemandDate" &&
              key !== "ExpirationDate" &&
              key !== "ProductionDate" &&
              key !== "DeliveryDate"
            ) {
              item[key] = 0;
            }
          });
        });
        this.api
          .save(sub)
          .then((res) => {
            if (res.Code === 0) {
              const id = res.Data === 0 ? this.data.OrderId : res.Data;
              this.isSave = true;
              this.is_orderUpdateStatus = false;
              this.editOrder(id, type);
              if(type !== 1){
                this.$message.success("保存成功");
              }
            } else {
              this.tableList = TableList;
              this.ProductModels = Product;
              this.data.Products = Product;
              this.$message.error(res.Msg);
            }
          })
          .catch((err) => {
            this.tableList = TableList;
            this.ProductModels = Product;
            this.data.Products = Product;
          });
      });
    },
    addList() {
      this.tableList.push({
        T: 0,
        StockQuantity: null,
        ExistQuantity: null,
        OrderProductId: 0,
        OrderId: 0,
        BarCode: "",
        ProductId: 0,
        UnitId: 0,
        Quantity: null,
        Offer: null,
        Discount: 100,
        TaxRate: null,
        Price: null,
        BatchNo: "",
        ProductionDate: "",
        ExpirationDate: "",
        TaxAmount: null,
        Amount: null,
        ColorId: null,
        LineAbortEmpId: 0,
        LineAbortDate: "",
        LineAbort: 0,
        DemandDate: "",
        PurchaseDemandId: 0,
        PurchaseDemandDetailId: 0,
        ProductNo: "",
        ProductSpec: "",
        ColorName: "",
        UnitName: "",
        SourceDocNo: "",
        SourceType: "",
        UnitId2: 0,
        Quantity2: null,
        ExecutionQuantity: null,
        ExecutionQuantity2: null,
        Unit2Name: "",
        TaxPrice: null,
        TaxLimit: null,
        DiscountAmount: null,
        Rate: null,
        ProductName: "",
        TradeUnitId: 0,
        TradeUnitNo: "",
        TradeUnitName: "",
        Remark: "",
      });
    },
  },
  watch: {
    "data.DemandDate": {
      handler: function (newVal) {
        this.tableList.forEach((item) => {
          item.DemandDate = newVal;
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .navbar-group {
  margin-bottom: 20px;

  .el-button {
    margin-left: 4px;
  }
}

.not-edit {
  display: inline-block;
  min-width: 190px;
  text-align: center;
  // border-bottom: 1px solid #e4e7ed;
}

.dropdown-item {
  padding: 5px 10px;
}

// /deep/ .tableList .el-select .el-input__inner {
//   margin-top: 10px;
//   border: none;
//   border-bottom: 1px solid #e4e7ed;
// }
</style>
